<app-screen-shell
  [contentClass]="{'container': true, 'player-management-embedded': embedded}"
  [showHeader]="!embedded"
  [title]="event ? event.name : ('events.players' | translate)"
  [subtitle]="'events.players' | translate"
  [loading]="loading && !(playerManagementReady$ | async)"
  loadingTitleKey="common.loadingData"
  [hideContentWhileLoading]="true"
  (back)="goBack()">

  @if (errorMsg) {
    <div class="alert alert-danger" role="alert">{{errorMsg}}</div>
  }
  @if (warningMsg) {
    <div class="alert alert-warning" role="alert">{{warningMsg}}</div>
  }
  @if (successMsg) {
    <div class="alert alert-success" role="alert">{{successMsg}}</div>
  }

  @if ((playerManagementReady$ | async) && event && event.viewedByManager) {
    <div>
      <div class="player-management-tabs" role="tablist" [attr.aria-label]="'events.players' | translate">
        <button type="button"
          class="player-management-tab"
          [class.is-active]="activeManagementTab === 'massUpdate'"
          (click)="selectManagementTab('massUpdate')"
          role="tab"
          [attr.aria-selected]="activeManagementTab === 'massUpdate'">
          {{ 'events.players' | translate }}
        </button>
        <button type="button"
          class="player-management-tab"
          [class.is-active]="activeManagementTab === 'stalePlayers'"
          (click)="selectManagementTab('stalePlayers')"
          role="tab"
          [attr.aria-selected]="activeManagementTab === 'stalePlayers'">
          {{ 'playerManagement.inactive.title' | translate }}
        </button>
        <button *ngIf="blockedPlayers.length > 0" type="button"
          class="player-management-tab"
          [class.is-active]="activeManagementTab === 'blockedPlayers'"
          (click)="selectManagementTab('blockedPlayers')"
          role="tab"
          [attr.aria-selected]="activeManagementTab === 'blockedPlayers'">
          {{ 'playerManagement.blocked.title' | translate }} <span class="badge badge-light">{{blockedPlayers.length}}</span>
        </button>
      </div>
      @if (activeManagementTab === 'massUpdate') {
      <div class="player-management-toolbar mb-3">
        <div class="player-management-toolbar-field">
          <label class="sr-only" for="nickNameFilter">{{ 'players.player' | translate }}</label>
          <input id="nickNameFilter" class="form-control" [(ngModel)]="nickNameFilter" (ngModelChange)="applyFilters()" [placeholder]="'playerManagement.searchByNickname' | translate" autocomplete="off">
        </div>
        <div class="player-management-toolbar-field">
          <label class="sr-only" for="statusFilter">{{ 'common.status' | translate }}</label>
          <select id="statusFilter" class="form-control" [(ngModel)]="statusFilter" (change)="applyFilters()">
            <option value="ALL">{{ 'playerManagement.allStatuses' | translate }}</option>
            <option [value]="playerEventInfoStatus.CONFIRMED">{{ displayStatusOption(playerEventInfoStatus.CONFIRMED) }}</option>
            <option [value]="playerEventInfoStatus.NOT_ANSWERED">{{ displayStatusOption(playerEventInfoStatus.NOT_ANSWERED) }}</option>
            <option [value]="playerEventInfoStatus.DECLINED">{{ displayStatusOption(playerEventInfoStatus.DECLINED) }}</option>
            <option [value]="playerEventInfoStatus.NOT_NOTIFIED">{{ displayStatusOption(playerEventInfoStatus.NOT_NOTIFIED) }}</option>
          </select>
        </div>
        <div class="player-management-toolbar-field">
          <label class="sr-only" for="memberTypeFilter">{{ 'playerManagement.type' | translate }}</label>
          <select id="memberTypeFilter" class="form-control" [(ngModel)]="memberTypeFilter" (change)="applyFilters()">
            <option value="ALL">{{ 'playerManagement.allTypes' | translate }}</option>
            <option [value]="teamMemberType.FIRST_TEAM">{{ displayTeamMemberOption(teamMemberType.FIRST_TEAM) }}</option>
            <option [value]="teamMemberType.RESERVE">{{ displayTeamMemberOption(teamMemberType.RESERVE) }}</option>
            <option [value]="teamMemberType.CANDIDATE">{{ displayTeamMemberOption(teamMemberType.CANDIDATE) }}</option>
          </select>
        </div>
      </div>
      <div class="players-list-wrapper card mb-4">
        <div class="card-body px-3 py-0">
          <div class="player-management-bulkbar py-3 border-bottom">
            <label class="player-management-select-all mb-0">
              <input type="checkbox" [checked]="areAllVisiblePlayersSelected()" (change)="toggleVisiblePlayersSelection($event.target.checked)" [disabled]="filteredPlayerEventInfos.length === 0 || actionInProgress || !!playerEventInfoPendingRemoval">
              <span>{{ 'playerManagement.selectVisible' | translate:{ count: filteredPlayerEventInfos.length } }}</span>
            </label>
            @if (getSelectedVisiblePlayerEventInfos().length > 0) {
            <div class="player-management-bulk-actions">
              <div class="player-management-bulk-group player-management-bulk-status-group">
                <span>{{ 'playerManagement.changeStatus' | translate }}</span>
                @for (status of statusOptions(); track status) {
                  <button type="button"
                    class="player-management-bulk-chip player-management-bulk-icon-chip"
                    (click)="bulkUpdateSelectedStatus(status)"
                    [disabled]="getSelectedVisiblePlayerEventInfos().length === 0 || actionInProgress"
                    [attr.aria-label]="displayStatusOption(status)"
                    [attr.title]="displayStatusOption(status)">
                    <i [class]="displayStatusIconClass(status)" aria-hidden="true"></i>
                  </button>
                }
              </div>
              <div class="player-management-bulk-group player-management-bulk-type-group">
                <span>{{ 'playerManagement.changeType' | translate }}</span>
                @for (type of teamMemberOptions(); track type) {
                  <button type="button" class="player-management-bulk-chip" (click)="bulkUpdateSelectedTeamMemberType(type)" [disabled]="getSelectedVisiblePlayerEventInfos().length === 0 || actionInProgress">
                    {{ displayTeamMemberOption(type) }}
                  </button>
                }
              </div>
              <div class="player-management-bulk-group player-management-bulk-remove-group">
                <span>{{ (playerEventInfo.teamMemberType === teamMemberType.CANDIDATE ? 'events.deny' : 'common.remove') | translate }}</span>
                <button type="button" class="btn btn-outline-danger btn-sm px-3" (click)="showRemoveConfirm = true" [disabled]="getSelectedPlayerEventInfos().length === 0 || actionInProgress">
                  <i [class]="('common.delete' | nogoshIcon) + ' mr-1'" aria-hidden="true"></i>
                  {{ 'playerManagement.removeSelected' | translate:{ count: getSelectedPlayerEventInfos().length } }}
                </button>
              </div>
            </div>
            }
            @if (showRemoveConfirm && getSelectedVisiblePlayerEventInfos().length > 0) {
              <div class="player-management-bulk-confirm alert alert-warning mb-0" role="alert">
                {{ 'playerManagement.removeSelectedConfirm' | translate:{ count: getSelectedPlayerEventInfos().length } }}
                <div class="mt-2">
                  <button type="button" class="btn btn-secondary btn-sm px-3 ml-2" (click)="showRemoveConfirm = false" [disabled]="actionInProgress">{{ 'common.cancel' | translate }}</button>
                  <button type="button" class="btn btn-danger btn-sm px-3" (click)="removeSelectedPlayers()" [disabled]="actionInProgress">{{ 'playerManagement.confirmRemoval' | translate }}</button>
                </div>
              </div>
            }
          </div>
          @if (filteredPlayerEventInfos.length === 0) {
            <div class="py-3 text-nogosh-grey3">{{ 'playerManagement.emptyFiltered' | translate }}</div>
          }
          @for (playerEventInfo of filteredPlayerEventInfos; track playerEventInfo) {
            <div class="player-management-row py-3 border-bottom border-bottom-not-last">
              <div class="player-management-grid">
                <div class="player-management-select">
                  <input type="checkbox" [(ngModel)]="selectedPlayerEventInfoIds[playerEventInfo.id]" [disabled]="actionInProgress || !!playerEventInfoPendingRemoval">
                </div>
                <div class="player-management-avatar">
                  <img [src]="playerEventInfo.player.avatar ? playerEventInfo.player.avatar : '../../assets/images/user1.jpg'"
                    onerror="this.src='../../assets/images/user1.jpg'"
                    class="rounded-circle border event-management-avatar-image"
                    style="width: 40px; height: 40px"
                    [alt]="'accessibility.userProfileImage' | translate">
                </div>
                <div class="player-management-name text-sm font-weight-500 line-height-10" title="{{playerEventInfo.player.nickName}}">
                  <button *ngIf="embedded" type="button" class="btn btn-link p-0 text-left" [disabled]="actionInProgress" (click)="playerSelected.emit(playerEventInfo)">{{playerEventInfo.player.nickName || playerEventInfo.player.name}}</button>
                  <div *ngIf="!embedded">{{playerEventInfo.player.nickName || playerEventInfo.player.name}}</div>
                  @if (playerManagementLabel(playerEventInfo)) {
                    <div class="text-nogosh-grey3 text-sm mt-1">{{ playerManagementLabel(playerEventInfo) }}</div>
                  }
                </div>
                <div class="player-management-status-controls" role="group" [attr.aria-label]="'playerManagement.playerStatusControls' | translate">
                  @for (status of statusOptions(); track status) {
                    <button type="button"
                      class="player-management-icon-pill"
                      [class.is-active]="playerEventInfo.status === status"
                      [attr.aria-label]="displayStatusOption(status)"
                      [attr.title]="displayStatusOption(status)"
                      [disabled]="actionInProgress || !!playerEventInfoPendingRemoval"
                      (click)="updateStatus(playerEventInfo, status)">
                      <i [class]="displayStatusIconClass(status)" aria-hidden="true"></i>
                    </button>
                  }
                </div>
                <div class="player-management-team-controls" role="group" [attr.aria-label]="'accessibility.playerType' | translate">
                  <button *ngIf="playerEventInfo.teamMemberType === teamMemberType.CANDIDATE" type="button" class="btn btn-primary btn-sm player-management-accept" [disabled]="actionInProgress || !!playerEventInfoPendingRemoval" (click)="updateTeamMemberType(playerEventInfo, teamMemberType.RESERVE)">{{ 'events.accept' | translate }}</button>
                  @for (type of teamMemberOptionsForPlayer(playerEventInfo); track type) {
                    <button type="button"
                      class="player-management-pill player-management-team-pill"
                      [class.is-active]="playerEventInfo.teamMemberType === type"
                      [disabled]="actionInProgress || !!playerEventInfoPendingRemoval"
                      (click)="updateTeamMemberType(playerEventInfo, type)">
                      {{ displayTeamMemberOption(type) }}
                    </button>
                  }
                </div>
                <div class="player-management-actions">
                  <button type="button" class="btn btn-outline-danger btn-sm px-3" (click)="confirmRemovePlayer(playerEventInfo)" [disabled]="actionInProgress || !!playerEventInfoPendingRemoval" [attr.aria-label]="'common.remove' | translate" [attr.title]="'common.remove' | translate">
                    <i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i>
                    <span class="player-management-action-text">{{ 'common.remove' | translate }}</span>
                  </button>
                </div>
              </div>
              @if (playerEventInfoPendingRemoval && playerEventInfoPendingRemoval.id === playerEventInfo.id) {
                <div class="player-management-confirm alert alert-warning mt-3 mb-0" role="alert">
                  {{ 'playerManagement.removePlayerConfirmPrefix' | translate }} <b>{{playerEventInfo.player.nickName}}</b> {{ 'playerManagement.removePlayerConfirmSuffix' | translate }}
                  <div class="mt-2 d-flex flex-wrap align-items-center">
                    <button type="button" class="btn btn-secondary btn-sm px-3 mr-2 mb-1" (click)="cancelRemovePlayer()" [disabled]="actionInProgress">{{ 'common.cancel' | translate }}</button>
                    <button type="button" class="btn btn-outline-danger btn-sm px-3 mr-2 mb-1" (click)="removePlayer(playerEventInfo)" [disabled]="actionInProgress">{{ (playerEventInfo.teamMemberType === teamMemberType.CANDIDATE ? 'events.deny' : 'playerManagement.confirmRemoval') | translate }}</button>
                    @if (!isGuestPlayer(playerEventInfo.player)) {
                      <button type="button" class="btn btn-danger btn-sm px-3 mb-1" (click)="blockPlayer(playerEventInfo)" [disabled]="actionInProgress">{{ (playerEventInfo.teamMemberType === teamMemberType.CANDIDATE ? 'playerManagement.blocked.rejectAndBlock' : 'playerManagement.blocked.removeAndBlock') | translate }}</button>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
      }
      @if (activeManagementTab === 'blockedPlayers') {
        <div class="card mb-4">
          <div class="card-body">
            <p class="text-nogosh-grey3 text-sm">{{ 'playerManagement.blocked.description' | translate }}</p>
            @if (blockedPlayersLoading) {
              <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
            }
            @if (!blockedPlayersLoading && blockedPlayers.length === 0) {
              <div class="text-nogosh-grey3">{{ 'playerManagement.blocked.empty' | translate }}</div>
            }
            @for (player of blockedPlayers; track player.playerId) {
              <div class="d-flex align-items-center justify-content-between py-3 border-bottom border-bottom-not-last">
                <div class="d-flex align-items-center">
                  <img [src]="player.avatar ? player.avatar : '../../assets/images/user1.jpg'" onerror="this.src='../../assets/images/user1.jpg'"
                    class="rounded-circle border mr-2 event-management-avatar-image" style="width: 40px; height: 40px" [alt]="'accessibility.userProfileImage' | translate">
                  <div class="font-weight-500">{{player.nickName || player.name}}</div>
                </div>
                <button type="button" class="btn btn-outline-primary btn-sm px-3" (click)="unblockPlayer(player)" [disabled]="actionInProgress">
                  {{ 'playerManagement.blocked.unblock' | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      }
      @if (activeManagementTab === 'stalePlayers') {
      <div class="card mb-4">
        <div class="card-body">
          <p class="text-nogosh-grey3 text-sm">{{ 'playerManagement.inactive.description' | translate }}</p>
          <div class="row align-items-end">
            <div class="col-12 col-md-3">
              <label for="cleanupMonths" class="mb-0">{{ 'playerManagement.inactive.threshold' | translate }}</label>
              <select id="cleanupMonths" class="form-control" [(ngModel)]="cleanupMonths">
                @for (months of cleanupMonthOptions; track months) {
                  <option [ngValue]="months">{{ 'playerManagement.inactive.monthCount' | translate:{ count: months } }}</option>
                }
              </select>
            </div>
            <div class="col-12 col-md-auto mt-3 mt-md-0 player-management-cleanup-actions">
              <button type="button" class="btn btn-primary btn-sm px-3" (click)="loadCleanupPlayers()" [disabled]="cleanupLoading || actionInProgress">
                @if (cleanupLoading) {
                  <app-delayed-indicator></app-delayed-indicator>
                }
                {{ 'playerManagement.inactive.find' | translate }}
              </button>
              @if (cleanupPlayers.length > 0 && !cleanupConfirm) {
                <button type="button" class="btn btn-outline-danger btn-sm px-3" (click)="cleanupConfirm = true" [disabled]="getSelectedCleanupPlayerIds().length === 0 || actionInProgress">
                  {{ 'playerManagement.inactive.removeSelected' | translate:{ count: getSelectedCleanupPlayerIds().length } }}
                </button>
              }
              @if (cleanupPlayers.length > 0 && cleanupConfirm) {
                <button type="button" class="btn btn-danger btn-sm px-3" (click)="removeCleanupPlayers()" [disabled]="getSelectedCleanupPlayerIds().length === 0 || actionInProgress">{{ 'playerManagement.confirmRemoval' | translate }}</button>
              }
              @if (cleanupPlayers.length > 0 && cleanupConfirm) {
                <button type="button" class="btn btn-secondary btn-sm px-3" (click)="cleanupConfirm = false" [disabled]="actionInProgress">{{ 'common.cancel' | translate }}</button>
              }
            </div>
          </div>
          @if (cleanupErrorMsg) {
            <div class="alert alert-danger mt-3" role="alert">{{cleanupErrorMsg}}</div>
          }
          @if (cleanupPlayers.length > 0) {
            <div class="table-responsive mt-3">
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th>{{ 'players.player' | translate }}</th>
                    <th>{{ 'playerManagement.inactive.lastPlayed' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (player of cleanupPlayers; track player) {
                    <tr>
                      <td class="align-middle">
                        <div class="d-flex align-items-center">
                          <input type="checkbox" class="mr-2" [(ngModel)]="selectedCleanupPlayerIds[player.playerId]" [disabled]="actionInProgress">
                          <img [src]="player.avatar ? player.avatar : '../../assets/images/user1.jpg'"
                            onerror="this.src='../../assets/images/user1.jpg'"
                            class="rounded-circle border mr-2 event-management-avatar-image"
                            style="width: 32px; height: 32px"
                            [alt]="'accessibility.userProfileImage' | translate">
                          <div>
                            <div class="font-weight-500">{{player.nickName || player.name}}</div>
                            @if (player.name && player.name !== player.nickName) {
                              <div class="text-nogosh-grey3 text-sm">{{player.name}}</div>
                            }
                          </div>
                        </div>
                      </td>
                      <td class="align-middle">
                        @if (player.lastPlayedAt) {
                          <span>{{player.lastPlayedAt | localizedDate:'d MMM yyyy'}}</span>
                        }
                        @if (!player.lastPlayedAt) {
                          <span>{{ 'playerManagement.inactive.neverPlayed' | translate }}</span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (cleanupPlayers.length === 0 && !cleanupLoading && !cleanupErrorMsg) {
            <div class="text-nogosh-grey3 mt-3">{{ (cleanupSearched ? 'playerManagement.inactive.emptyForThreshold' : 'playerManagement.inactive.searchPrompt') | translate }}</div>
          }
          @if (cleanupConfirm) {
            <div class="alert alert-warning mt-3" role="alert">
              {{ 'playerManagement.removeSelectedConfirm' | translate:{ count: getSelectedCleanupPlayerIds().length } }}
            </div>
          }
        </div>
      </div>
      }
    </div>
  }
</app-screen-shell>
